import { useCallback, useState } from 'react';

const REFEREE_STATUS_NOTIFICATIONS = {
  1: {
    title: 'Pending Referee report',
    message: 'Referee report is pending. Action is required.',
  },
  2: {
    title: 'Report Submitted',
    message: 'Referee report submitted successfully.',
  },
  3: {
    title: 'Report Declined',
    message: 'Referee report has been declined.',
  },
  4: {
    title: 'Existing Report Used',
    message: 'Existing report has been used successfully.',
  },
  5: {
    title: 'Extension Requested',
    message: 'Extension request has been submitted successfully.',
  },
  6: {
    title: 'Extension Approved',
    message: 'Extension has been approved.',
  },
};

const DEFAULT_NOTIFICATION = {
  title: 'Success',
  message: 'Action completed successfully.',
};

export const getRefereeStatusNotification = (statusId) =>
  REFEREE_STATUS_NOTIFICATIONS[statusId] || DEFAULT_NOTIFICATION;

export const useWizardNotification = () => {
  const [notification, setNotification] = useState(null);

  const showNotification = useCallback((title, message) => {
    if (!title && !message) {
      setNotification(null);
      return;
    }
    setNotification({ title, message });
  }, []);

  return { notification, showNotification };
};
